import { Component, OnInit, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

import { AppService } from 'src/app/app.service';


@Component({
    selector: 'app-bottom-sheet-dialog',
    templateUrl: './bottom-sheet-dialog.component.html',
    styleUrls: ['./bottom-sheet-dialog.component.scss'],
    standalone: false
})
export class BottomSheetDialogComponent implements OnInit {

	constructor(
		public appService: AppService,
		private bottomSheetRef: MatBottomSheetRef<BottomSheetDialogComponent>,
		@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
	) {
		
	}

	openLink(act, event: MouseEvent ): void {
		this.bottomSheetRef.dismiss(act);
		event.preventDefault();
	}

	ngOnInit() {
	}

}
